module.exports = __webpack_public_path__ + "img/platinum.be5030ca.webp";